module.exports = __webpack_public_path__ + "img/fr_true_gem_edited.4e9d297f.png";